var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.tabLoading)?_c('Form',{attrs:{"data":_vm.branding},on:{"color-change":_vm.brandingChange,"dirty-tab":_vm.setDirtyTab,"update-image":_vm.updateImage}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }